module.exports = __webpack_public_path__ + "img/investment-plan-mobile.9e321559.webp";